import React from 'react';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { timestampToDate2 } from './utils';
import Setlist from './Setlist';
import { PlaybackProvider } from './PlaybackContext';

function showTooltip(show) {
    if (!show) return '';
    return `${show.venue} — ${show.city}, ${show.state} (${timestampToDate2(show.date)})`;
}

export default function ShowDetails({ data, setSelectedShow, currentIndex, shows, onNavigateShow }) {
    const [showData, setShowData] = React.useState(null);

    React.useEffect(() => {
        if ( data ) {
            const { show, imageUrl } = data;
            setShowData({ ...show, imageUrl })
        }
    }, [data]);
    
    return (
        !showData ? null :
        <Grid container>
            {/* Navigation Buttons */}
            <Grid item xs={12} sx={{
                display: "flex",
                alignItems: "center",
                p: {xs: 1, sm: 0},
            }}>
                <Box sx={{ flex: 1 }}>
                    <Button
                        variant="text"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => setSelectedShow(null)}
                        sx={{ color: "white" }}
                    >
                        Back
                    </Button>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title={showTooltip(shows[currentIndex - 1])}>
                        <span>
                            <Button
                                variant="text"
                                startIcon={<NavigateBeforeIcon />}
                                disabled={currentIndex <= 0}
                                onClick={() => onNavigateShow(currentIndex - 1)}
                                sx={{ color: "white", '&.Mui-disabled': { color: 'grey.700' } }}
                            >
                                Next Show
                            </Button>
                        </span>
                    </Tooltip>
                    <Tooltip title={showTooltip(shows[currentIndex + 1])}>
                        <span>
                            <Button
                                variant="text"
                                endIcon={<NavigateNextIcon />}
                                disabled={currentIndex < 0 || currentIndex >= shows.length - 1}
                                onClick={() => onNavigateShow(currentIndex + 1)}
                                sx={{ color: "white", '&.Mui-disabled': { color: 'grey.700' } }}
                            >
                                Previous Show
                            </Button>
                        </span>
                    </Tooltip>
                </Box>
                <Box sx={{ flex: 1 }} />
            </Grid>

            {/* Show Image */}
            <Grid item xs={12} md 
                sx={{
                    display: "flex",
                    flexGrow: 0,
                    pt: {
                        md: 3
                    },
                    pl: {
                        md: 3
                    },
                    justifyContent: {
                        xs: "center",
                        lg: "flex-start",
                    }
                }}
            >
                <Grid component="img" src={showData.imageUrl} alt='venue'
                    sx={{
                        maxWidth: {
                            xs: "325px",
                            sm: "375px"
                        }
                    }}
                />
            </Grid>
            
            {/* Show Details */}
            <Grid item flexDirection="column" 
                sx={{ 
                    display: "flex",
                    flexGrow: 1,
                    
                    pt: {
                        xs: 2,
                        md: 3
                    },
                    gap: 1,
                    alignItems: {
                        xs: "center",
                        md: "flex-start"
                    },
                    ml: {md: 4},
                }}
            >
                <Typography variant="h4" 
                    sx={{
                        fontSize: {
                            sm: 30,
                            md: 40
                        }
                    }}
                >
                    {showData.venue}
                </Typography>

                <Typography variant="body1"
                    sx={{
                        fontSize: {
                            sm: 25,
                        }
                    }}    
                >
                    {`${showData.city}, ${showData.state}`}
                </Typography>

                <Typography variant="body1"
                    sx={{
                        fontSize: {
                            sm: 25,
                        }
                    }}
                >
                    <strong>{timestampToDate2(showData.date)}</strong>
                </Typography>
            </Grid>

            {/* Setlist */}
            <PlaybackProvider>
                <Setlist showData={showData} />
            </PlaybackProvider>
        </Grid>
    )
}